// extracted by mini-css-extract-plugin
export default {"page":"Form_page__zdC0S","wrapper":"Form_wrapper__JDyLn"};